// @flow
import * as Immutable from 'immutable';
import ImmutableModel from './ImmutableModel';

import { ChecklistItem, SelectedChecklistItem } from './ChecklistItem';

import type {
    ChecklistItemModelType,
    SelectedChecklistItemModelType
} from './ChecklistItem';

export type ChecklistModelType = {
    items: Array<ChecklistItemModelType>
};

export type SelectedChecklistModelType = {
    items: Array<SelectedChecklistItemModelType>
};

export type TaskChecklistsModelType = {
    cancelled: ?ChecklistModelType,
    completed: ?ChecklistModelType,
    started: ?ChecklistModelType,
    arrived: ?ChecklistModelType,
    transacting: ?ChecklistModelType,
    slaDelay: ?ChecklistModelType
};

export type SelectedChecklistsModelType = {
    cancelled: ?SelectedChecklistModelType,
    completed: ?SelectedChecklistModelType,
    started: ?SelectedChecklistModelType,
    arrived: ?SelectedChecklistModelType,
    transacting: ?SelectedChecklistModelType,
    slaDelay: ?SelectedChecklistModelType
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class Checklist extends ImmutableModel {
    static fromJS(json: ChecklistModelType): Checklist {
        const state: Object = Object.assign({}, json);
        state.items = Immutable.List(state.items).map(item =>
            ChecklistItem.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    toJS(): ChecklistModelType {
        return {
            items: this.items.toArray().map(item => item.toJS())
        };
    }

    get items(): Immutable.List<ChecklistItem> {
        return this._state.get('items');
    }

    setItems(items: Immutable.List<ChecklistItem>): this {
        return this.clone(this._state.set('items', items));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class TaskChecklists extends ImmutableModel {
    static fromJS(json: TaskChecklistsModelType): TaskChecklists {
        const state: Object = Object.assign({}, json);
        state.cancelled = state.cancelled
            ? Checklist.fromJS(state.cancelled)
            : state.cancelled;
        state.completed = state.completed
            ? Checklist.fromJS(state.completed)
            : state.completed;
        state.started = state.started
            ? Checklist.fromJS(state.started)
            : state.started;
        state.arrived = state.arrived
            ? Checklist.fromJS(state.arrived)
            : state.arrived;
        state.transacting = state.transacting
            ? Checklist.fromJS(state.transacting)
            : state.transacting;
        state.slaDelay = state.slaDelay
            ? Checklist.fromJS(state.slaDelay)
            : state.slaDelay;
        return new this(Immutable.Map(state));
    }

    toJS(): TaskChecklistsModelType {
        return {
            cancelled: this.cancelled ? this.cancelled.toJS() : this.cancelled,
            completed: this.completed ? this.completed.toJS() : this.completed,
            started: this.started ? this.started.toJS() : this.started,
            arrived: this.arrived ? this.arrived.toJS() : this.arrived,
            transacting: this.transacting
                ? this.transacting.toJS()
                : this.transacting,
            slaDelay: this.slaDelay ? this.slaDelay.toJS() : this.slaDelay
        };
    }

    get cancelled(): ?Checklist {
        return this._state.get('cancelled');
    }

    setCancelled(cancelled: ?Checklist): this {
        return this.clone(this._state.set('cancelled', cancelled));
    }

    get completed(): ?Checklist {
        return this._state.get('completed');
    }

    setCompleted(completed: ?Checklist): this {
        return this.clone(this._state.set('completed', completed));
    }

    get started(): ?Checklist {
        return this._state.get('started');
    }

    setStarted(started: ?Checklist): this {
        return this.clone(this._state.set('started', started));
    }

    get arrived(): ?Checklist {
        return this._state.get('arrived');
    }

    setArrived(arrived: ?Checklist): this {
        return this.clone(this._state.set('arrived', arrived));
    }

    get transacting(): ?Checklist {
        return this._state.get('transacting');
    }

    setTransacting(transacting: ?Checklist): this {
        return this.clone(this._state.set('transacting', transacting));
    }

    get slaDelay(): ?Checklist {
        return this._state.get('slaDelay');
    }

    setSlaDelay(slaDelay: ?Checklist): this {
        return this.clone(this._state.set('slaDelay', slaDelay));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class SelectedChecklist extends ImmutableModel {
    static fromJS(json: SelectedChecklistModelType): SelectedChecklist {
        const state: Object = Object.assign({}, json);
        state.items = Immutable.List(state.items).map(item =>
            SelectedChecklistItem.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    toJS(): SelectedChecklistModelType {
        return {
            items: this.items.toArray().map(item => item.toJS())
        };
    }

    get items(): Immutable.List<SelectedChecklistItem> {
        return this._state.get('items');
    }

    setItems(items: Immutable.List<SelectedChecklistItem>): this {
        return this.clone(this._state.set('items', items));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class SelectedChecklists extends ImmutableModel {
    static fromJS(json: SelectedChecklistsModelType): SelectedChecklists {
        const state: Object = Object.assign({}, json);
        state.cancelled = state.cancelled
            ? SelectedChecklist.fromJS(state.cancelled)
            : state.cancelled;
        state.completed = state.completed
            ? SelectedChecklist.fromJS(state.completed)
            : state.completed;
        state.started = state.started
            ? SelectedChecklist.fromJS(state.started)
            : state.started;
        state.arrived = state.arrived
            ? SelectedChecklist.fromJS(state.arrived)
            : state.arrived;
        state.transacting = state.transacting
            ? SelectedChecklist.fromJS(state.transacting)
            : state.transacting;
        state.slaDelay = state.slaDelay
            ? SelectedChecklist.fromJS(state.slaDelay)
            : state.slaDelay;
        return new this(Immutable.Map(state));
    }

    toJS(): SelectedChecklistsModelType {
        return {
            cancelled: this.cancelled ? this.cancelled.toJS() : this.cancelled,
            completed: this.completed ? this.completed.toJS() : this.completed,
            started: this.started ? this.started.toJS() : this.started,
            arrived: this.arrived ? this.arrived.toJS() : this.arrived,
            transacting: this.transacting
                ? this.transacting.toJS()
                : this.transacting,
            slaDelay: this.slaDelay ? this.slaDelay.toJS() : this.slaDelay
        };
    }

    get cancelled(): ?SelectedChecklist {
        return this._state.get('cancelled');
    }

    setCancelled(cancelled: ?SelectedChecklist): this {
        return this.clone(this._state.set('cancelled', cancelled));
    }

    get completed(): ?SelectedChecklist {
        return this._state.get('completed');
    }

    setCompleted(completed: ?SelectedChecklist): this {
        return this.clone(this._state.set('completed', completed));
    }

    get started(): ?SelectedChecklist {
        return this._state.get('started');
    }

    setStarted(started: ?SelectedChecklist): this {
        return this.clone(this._state.set('started', started));
    }

    get arrived(): ?SelectedChecklist {
        return this._state.get('arrived');
    }

    setArrived(arrived: ?SelectedChecklist): this {
        return this.clone(this._state.set('arrived', arrived));
    }

    get transacting(): ?SelectedChecklist {
        return this._state.get('transacting');
    }

    setTransacting(transacting: ?SelectedChecklist): this {
        return this.clone(this._state.set('transacting', transacting));
    }

    get slaDelay(): ?SelectedChecklist {
        return this._state.get('slaDelay');
    }

    setSlaDelay(slaDelay: ?SelectedChecklist): this {
        return this.clone(this._state.set('slaDelay', slaDelay));
    }
}
